export default __webpack_public_path__ + "static/media/vital_sign.915a272b.svg";